<header
  class="bcledger-header d-flex align-items-center justify-content-between has-border mb-2">
  <h2 class="mb-0">Freight Details</h2>
  <div class="bcledger-panel d-flex justify-content-between ms-2 me-auto">
    <div class="lds-ring inline me-auto ms-2" *ngIf="false">
      <jni-spinner></jni-spinner>
    </div>
  </div>
  <span *ngIf="isModal" class="mx-3" (click)="closeModal()"
    ><i class="pi pi-times"></i
  ></span>
</header>

<div class="col-lg-12">
  <div class="row child">
    <p-card class="card-spacing-0">
      <div class="col-12 adduser-container-hgt">
        <form [formGroup]="freightDetailForm" class="pb-2">
          <div class="row" formGroupName="freightDetail">
            <div class="col-4">
              <div class="gray-bg-rounded">
                <h2 class="mb-2">General</h2>
                <div class="row">
                  <div class="col">
                    <div class="form-group has-float-label mb-2">
                      <label class="form-label" for="FreightNumber"
                        >Freight Number</label
                      >
                      <input
                        pInputText
                        jniAutoCompleteBlocker
                        type="text"
                        class="form-control"
                        id="FreightNumber"
                        name="FreightNumber"
                        formControlName="freightNumber" />
                    </div>
                    <div class="form-group has-float-label mb-2">
                      <label class="form-label" for="trackingNumber"
                        >Tracking Number</label
                      >
                      <input
                        pInputText
                        jniAutoCompleteBlocker
                        type="text"
                        class="form-control"
                        id="TrackingNumber"
                        name="TrackingNumber"
                        formControlName="trackingNumber" />
                    </div>
                    <div
                      class="form-group has-float-label mb-2"
                      *ngIf="showFreightCostPrice">
                      <label class="form-label" for="FreightCostPrice"
                        >Freight Cost Price</label
                      >
                      <input
                        pInputText
                        jniAutoCompleteBlocker
                        type="text"
                        class="form-control"
                        id="FreightCostPrice"
                        name="FreightCostPrice"
                        formControlName="freightCostPrice" />
                    </div>
                    <div class="form-group has-float-label mb-2">
                      <label class="form-label" for="ShipStatus"
                        >Ship Status</label
                      >
                      <input
                        pInputText
                        jniAutoCompleteBlocker
                        type="text"
                        class="form-control"
                        id="ShipStatus"
                        name="ShipStatus"
                        formControlName="shipStatus" />
                    </div>
                    <div class="form-group has-float-label mb-2">
                      <label class="form-label" for="ShippingMethod"
                        >Shipping Method</label
                      >
                      <input
                        pInputText
                        jniAutoCompleteBlocker
                        type="text"
                        class="form-control"
                        id="ShippingMethod"
                        name="ShippingMethod"
                        formControlName="shippingMethod" />
                    </div>
                    <div class="form-group has-float-label mb-2">
                      <label class="form-label" for="ShipDate">Ship Date</label>
                      <input
                        pInputText
                        jniAutoCompleteBlocker
                        type="text"
                        class="form-control"
                        id="ShipDate"
                        name="ShipDate"
                        disabled
                        [value]="shipDate | date: 'MM-dd-yyyy'" />
                    </div>
                    <div class="form-group has-float-label mb-2">
                      <label class="form-label" for="DeliveryDate"
                        >Delivery Date</label
                      >
                      <input
                        pInputText
                        jniAutoCompleteBlocker
                        type="text"
                        class="form-control"
                        id="DeliveryDate"
                        name="DeliveryDate"
                        disabled
                        [value]="deliveryDate | date: 'MM-dd-yyyy'" />
                    </div>
                    <div class="form-group has-float-label mb-2">
                      <label class="form-label" for="PODName">POD Name</label>
                      <input
                        pInputText
                        jniAutoCompleteBlocker
                        type="text"
                        class="form-control"
                        id="PODName"
                        name="PODName"
                        formControlName="pODName" />
                    </div>
                    <div class="form-group has-float-label mb-2">
                      <label
                        class="form-label"
                        for="HundredWeightTrackingNumber"
                        >Hundred Weight Tracking Number</label
                      >
                      <input
                        pInputText
                        jniAutoCompleteBlocker
                        type="text"
                        class="form-control"
                        id="HundredWeight rackingNumber"
                        name="HundredWeightTrackingNumber"
                        formControlName="hundredWeightTrackingNumber" />
                    </div>
                    <div class="form-group has-float-label mb-2">
                      <label class="form-label" for="JNIReference2"
                        >JNI Reference 2</label
                      >
                      <input
                        pInputText
                        jniAutoCompleteBlocker
                        type="text"
                        class="form-control"
                        name="JNIReference2"
                        formControlName="jNIReference2" />
                    </div>
                    <div class="form-group has-float-label mb-2">
                      <label class="form-label" for="JNIReference3"
                        >JNI Reference 3</label
                      >
                      <input
                        pInputText
                        jniAutoCompleteBlocker
                        type="text"
                        class="form-control"
                        name="JNIReference3"
                        formControlName="jNIReference3" />
                    </div>
                    <div class="form-group has-float-label mb-2">
                      <label class="form-label" for="JNIReference4"
                        >JNI Reference 4</label
                      >
                      <input
                        pInputText
                        jniAutoCompleteBlocker
                        type="text"
                        class="form-control"
                        name="JNIReference4"
                        formControlName="jNIReference4" />
                    </div>
                    <div class="form-group has-float-label mb-2">
                      <label class="form-label" for="JNIReference5"
                        >JNI Reference 5</label
                      >
                      <input
                        pInputText
                        jniAutoCompleteBlocker
                        type="text"
                        class="form-control"
                        name="JNIReference5"
                        formControlName="jNIReference5" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="gray-bg-rounded">
                <h2 class="mb-2">Shipper</h2>
                <div class="form-group has-float-label mb-2">
                  <label class="form-label" for="shipperName"
                    >Shipper Name</label
                  >
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    type="email"
                    name="ShipperName"
                    class="form-control"
                    formControlName="shipperName" />
                </div>
                <div class="form-group has-float-label mb-2">
                  <label class="form-label" for="ShipperCompany"
                    >Shipper Company</label
                  >
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    type="text"
                    name="ShipperCompany"
                    class="form-control"
                    formControlName="shipperCompany" />
                </div>
                <div class="form-group has-float-label mb-2">
                  <label class="form-label" for="Address">Address</label>
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    type="text"
                    name="Address"
                    class="form-control"
                    formControlName="shipperAddress" />
                </div>
                <div class="form-group has-float-label mb-2">
                  <label class="form-label" for="City">City</label>
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    type="text"
                    name="City"
                    class="form-control"
                    formControlName="shipperCity" />
                </div>
                <div class="form-group has-float-label mb-2">
                  <label class="form-label" for="State">State</label>
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    type="text"
                    class="form-control"
                    name="State"
                    formControlName="shipperState" />
                </div>
                <div class="form-group has-float-label mb-2">
                  <label class="form-label" for="PostalCode"
                    >ZIP/PostalCode</label
                  >
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    type="text"
                    class="form-control"
                    name="PostalCode"
                    formControlName="shipperZip" />
                </div>
                <div class="form-group has-float-label mb-2">
                  <label class="form-label" for="Country">Country/region</label>
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    type="text"
                    class="form-control"
                    name="Country"
                    formControlName="shipperCountry" />
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="gray-bg-rounded">
                <h2 class="mb-2">Recipient</h2>
                <div class="form-group has-float-label mb-2">
                  <label class="form-label" for="recipientName"
                    >Receipient Name</label
                  >
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    type="email"
                    name="ReceipientName"
                    class="form-control"
                    formControlName="recipientName" />
                </div>
                <div class="form-group has-float-label mb-2">
                  <label class="form-label" for="Receipient"
                    >Receipient Company</label
                  >
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    type="text"
                    name="Receipient"
                    class="form-control"
                    formControlName="recipientCompany" />
                </div>
                <div class="form-group has-float-label mb-2">
                  <label class="form-label" for="Address">Address</label>
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    type="text"
                    name="Address"
                    class="form-control"
                    formControlName="recipientAddress" />
                </div>
                <div class="form-group has-float-label mb-2">
                  <label class="form-label" for="City">City</label>
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    type="text"
                    name="City"
                    class="form-control"
                    formControlName="recipientCity" />
                </div>
                <div class="form-group has-float-label mb-2">
                  <label class="form-label" for="State">State</label>
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    type="text"
                    class="form-control"
                    name="State"
                    formControlName="recipientState" />
                </div>
                <div class="form-group has-float-label mb-2">
                  <label class="form-label" for="PostalCode"
                    >ZIP/PostalCode</label
                  >
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    type="text"
                    class="form-control"
                    name="PostalCode"
                    formControlName="recipientZip" />
                </div>
                <div class="form-group has-float-label mb-2">
                  <label class="form-label" for="Country">Country/region</label>
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    type="text"
                    class="form-control"
                    name="Country"
                    formControlName="recipientCountry" />
                </div>
                <div class="form-group has-float-label mb-2">
                  <label class="form-label" for="Telephone">Telephone</label>
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    type="text"
                    class="form-control"
                    name="Telephone"
                    formControlName="recipientPhone" />
                </div>
              </div>
            </div>
          </div>
          <div>
            <jni-packaging-details
              [parent]="freightDetailForm"></jni-packaging-details>
          </div>
        </form>
      </div>
    </p-card>
  </div>
</div>

<!-- <div class="bcledger py-4">
  <header
    class="bcledger-header d-flex align-items-center justify-content-between has-border pb-2 mb-2"
    *ngIf="!trackingNumber">
    <h1 class="m-0">Freight Details</h1>
    <div class="lds-ring inline me-auto ms-2" *ngIf="false">
      <div></div>
      <div></div>
      <div></div>
    </div>
  </header>
</div> -->
